/*
 * File: cell-multi-hierachy.ts
 * File Created: 2024-06-05 09:47:58
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { IQuickUnitAny } from "@root/core/utilities/quick-helper";
import { Component, Prop } from "vue-property-decorator";

@Component
@UITag.setDefault({
    uiAlign: "r",
    uiProvideRow: "true",
})
export default class CellMultiHierachy extends BaseTableBodyCell {
    @Prop({ type: Array, required: true })
    quicks!: IQuickUnitAny[][];
}
